import PaginatedReport from "../../../../common/components/PaginatedReport";

const convertToTableData = (data) => {
  const groupedByLevel = data.reduce((acc, item) => {
    if (!acc[item.teachingLevel]) {
      acc[item.teachingLevel] = [];
    }
    acc[item.teachingLevel].push(item);
    return acc;
  }, {});

  const processedData = [];

  Object.entries(groupedByLevel).forEach(([level, positions]) => {
    const section = {
      teachingLevel: level,
      positions: positions.map((pos) => ({
        position: pos.position,
        male: pos.male,
        female: pos.female,
        total: pos.total,
      })),
      totals: {
        male: positions.reduce((sum, pos) => sum + pos.male, 0),
        female: positions.reduce((sum, pos) => sum + pos.female, 0),
        total: positions.reduce((sum, pos) => sum + pos.total, 0),
      },
    };

    processedData.push(section);
  });

  return processedData;
};

export default function PositionDistributionChart({ data, scope }) {
  const sectionsData = convertToTableData(data);

  return (
    <div style={{ width: "100%" }}>
      {sectionsData.map((section, sectionIndex) => {
        if (sectionIndex === 0 && scope !== "RTB") {
          return (
            <div
              key={`section-${section.teachingLevel}`}
              style={{ marginBottom: "20px" }}
            >
              <table
                style={{
                  borderCollapse: "collapse",
                  width: "100%",
                }}
              >
                <thead>
                  <tr>
                    <th
                      style={{
                        border: "1px solid #ddd",
                        padding: "10px 10px 10px 20px",
                        textAlign: "left",
                        backgroundColor: "rgb(1, 81, 152)",
                        color: "white",
                      }}
                    >
                      {section.teachingLevel}
                    </th>
                    <th
                      style={{
                        border: "1px solid #ddd",
                        padding: "10px",
                        textAlign: "center",
                        backgroundColor: "rgb(1, 81, 152)",
                        color: "white",
                      }}
                    >
                      Male
                    </th>
                    <th
                      style={{
                        border: "1px solid #ddd",
                        padding: "10px",
                        textAlign: "center",
                        backgroundColor: "rgb(1, 81, 152)",
                        color: "white",
                      }}
                    >
                      Female
                    </th>
                    <th
                      style={{
                        border: "1px solid #ddd",
                        padding: "10px",
                        textAlign: "center",
                        backgroundColor: "rgb(1, 81, 152)",
                        color: "white",
                      }}
                    >
                      Total
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {section.positions.map((position, posIndex) => (
                    <tr
                      key={`position-${section.teachingLevel}-${posIndex}`}
                      style={{
                        backgroundColor:
                          posIndex % 2 === 0 ? "#f9f9f9" : "#fff",
                      }}
                    >
                      <td
                        style={{
                          border: "1px solid #ddd",
                          padding: "10px 10px 10px 20px",
                          paddingLeft: "40px",
                        }}
                      >
                        {position.position}
                      </td>
                      <td
                        style={{
                          border: "1px solid #ddd",
                          padding: "10px",
                          textAlign: "center",
                          backgroundColor:
                            posIndex % 2 === 0
                              ? "#f9f9f9"
                              : "rgb(237, 242, 247)",
                        }}
                      >
                        {position.male?.toLocaleString()}
                      </td>
                      <td
                        style={{
                          border: "1px solid #ddd",
                          padding: "10px",
                          textAlign: "center",
                          backgroundColor:
                            posIndex % 2 === 0
                              ? "#f9f9f9"
                              : "rgb(252, 236, 223)",
                        }}
                      >
                        {position.female?.toLocaleString()}
                      </td>
                      <td
                        style={{
                          border: "1px solid #ddd",
                          padding: "10px",
                          textAlign: "center",
                          backgroundColor:
                            posIndex % 2 === 0 ? "#f9f9f9" : "#f0f0f0",
                          fontWeight: "500",
                        }}
                      >
                        {position.total?.toLocaleString()}
                      </td>
                    </tr>
                  ))}
                  <tr
                    style={{
                      backgroundColor: "rgb(197, 221, 241)",
                      fontWeight: "bold",
                    }}
                  >
                    <td
                      style={{
                        border: "1px solid #ddd",
                        padding: "12px 10px 12px 20px",
                        textAlign: "right",
                        backgroundColor: "white",
                        borderBottom: "none",
                          borderLeft: "none",
                      }}
                    ></td>
                    <td
                      style={{
                        border: "1px solid #ddd",
                        padding: "10px",
                        textAlign: "center",
                        color: "rgb(1, 81, 152)",
                      }}
                    >
                      {section.totals.male?.toLocaleString()}
                    </td>
                    <td
                      style={{
                        border: "1px solid #ddd",
                        padding: "10px",
                        textAlign: "center",
                        color: "rgb(237, 108, 2)",
                      }}
                    >
                      {section.totals.female?.toLocaleString()}
                    </td>
                    <td
                      style={{
                        border: "1px solid #ddd",
                        padding: "10px",
                        textAlign: "center",
                        fontWeight: "bold",
                      }}
                    >
                      {section.totals.total?.toLocaleString()}
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          );
        }

        return (
          <div
            key={`section-${section.teachingLevel}`}
            style={{ marginBottom: "20px" }}
          >
            <PaginatedReport
              data={section.positions}
              rowsPerPage={10}
              renderTable={(paginatedPositions) => (
                <table
                  style={{
                    borderCollapse: "collapse",
                    width: "100%",
                  }}
                >
                  <thead>
                    <tr>
                      <th
                        style={{
                          border: "1px solid #ddd",
                          padding: "10px 10px 10px 20px",
                          textAlign: "left",
                          backgroundColor: "rgb(1, 81, 152)",
                          color: "white",
                        }}
                      >
                        {section.teachingLevel}
                      </th>
                      <th
                        style={{
                          border: "1px solid #ddd",
                          padding: "10px",
                          textAlign: "center",
                          backgroundColor: "rgb(1, 81, 152)",
                          color: "white",
                        }}
                      >
                        Male
                      </th>
                      <th
                        style={{
                          border: "1px solid #ddd",
                          padding: "10px",
                          textAlign: "center",
                          backgroundColor: "rgb(1, 81, 152)",
                          color: "white",
                        }}
                      >
                        Female
                      </th>
                      <th
                        style={{
                          border: "1px solid #ddd",
                          padding: "10px",
                          textAlign: "center",
                          backgroundColor: "rgb(1, 81, 152)",
                          color: "white",
                        }}
                      >
                        Total
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    {paginatedPositions.map((position, posIndex) => (
                      <tr
                        key={`position-${section.teachingLevel}-${posIndex}`}
                        style={{
                          backgroundColor:
                            posIndex % 2 === 0 ? "#f9f9f9" : "#fff",
                        }}
                      >
                        <td
                          style={{
                            border: "1px solid #ddd",
                            padding: "10px 10px 10px 20px",
                            paddingLeft: "40px",
                          }}
                        >
                          {position.position}
                        </td>
                        <td
                          style={{
                            border: "1px solid #ddd",
                            padding: "10px",
                            textAlign: "center",
                            backgroundColor:
                              posIndex % 2 === 0
                                ? "#f9f9f9"
                                : "rgb(237, 242, 247)",
                          }}
                        >
                          {position.male?.toLocaleString()}
                        </td>
                        <td
                          style={{
                            border: "1px solid #ddd",
                            padding: "10px",
                            textAlign: "center",
                            backgroundColor:
                              posIndex % 2 === 0
                                ? "#f9f9f9"
                                : "rgb(252, 236, 223)",
                          }}
                        >
                          {position.female?.toLocaleString()}
                        </td>
                        <td
                          style={{
                            border: "1px solid #ddd",
                            padding: "10px",
                            textAlign: "center",
                            backgroundColor:
                              posIndex % 2 === 0 ? "#f9f9f9" : "#f0f0f0",
                            fontWeight: "500",
                          }}
                        >
                          {position.total?.toLocaleString()}
                        </td>
                      </tr>
                    ))}
                    <tr
                      style={{
                        backgroundColor: "rgb(197, 221, 241)",
                        fontWeight: "bold",
                      }}
                    >
                      <td
                        style={{
                          border: "1px solid #ddd",
                          padding: "12px 10px 12px 20px",
                          textAlign: "right",
                          backgroundColor: "white",
                          borderBottom: "none",
                          borderLeft: "none",
                          borderBottom: "none",
                          borderLeft: "none",
                        }}
                      ></td>
                      <td
                        style={{
                          border: "1px solid #ddd",
                          padding: "10px",
                          textAlign: "center",
                          color: "rgb(1, 81, 152)",
                        }}
                      >
                        {section.totals.male?.toLocaleString()}
                      </td>
                      <td
                        style={{
                          border: "1px solid #ddd",
                          padding: "10px",
                          textAlign: "center",
                          color: "rgb(237, 108, 2)",
                        }}
                      >
                        {section.totals.female?.toLocaleString()}
                      </td>
                      <td
                        style={{
                          border: "1px solid #ddd",
                          padding: "10px",
                          textAlign: "center",
                          fontWeight: "bold",
                        }}
                      >
                        {section.totals.total?.toLocaleString()}
                      </td>
                    </tr>
                  </tbody>
                </table>
              )}
            />
          </div>
        );
      })}
    </div>
  );
}
